export const PLACE_ORDER = "PLACE_ORDER";
export const PAYMENT_FAILED = "PAYMENT_FAILED";
